<template>
  <div class="app-container column-list">
    <div class="column-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="column-list-filter-label">名称</label>
            <el-input class="column-list-filter-value" v-model.trim="listQuery.circleName" @keyup.enter.native="searchChange" clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="column-list-filter-label">作者</label>
            <el-input class="column-list-filter-value" v-model.trim="listQuery.createdByName" @keyup.enter.native="searchChange" clearable size="small"></el-input>
          </div>
        </el-col>

        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="column-list-filter-label">状态</label>
            <el-select class="column-list-filter-value" v-model="listQuery.isActive" clearable size="small">
              <el-option
                v-for="item in isActiveOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <label class="column-list-filter-label">创建时间</label>
            <el-date-picker
               class="column-list-filter-date"
              v-model="listQuery.createTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small">
            </el-date-picker>
          </div>
        </el-col>
        <div>
          <el-button class="column-list-filter-reset" size="small" @click="searchReset">清空</el-button>
          <el-button class="column-list-filter-search" type="primary" size="small" @click="searchChange">搜索</el-button>
        </div>
      </el-row>
    </div>
    <basic-container>
      <avue-crud ref="crud"
                 :page.sync="page"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 @current-change="currentChange"
                 @refresh-change="refreshChange"
                 @sort-change="sortChange"
                 @size-change="sizeChange"
                 @row-del="rowDel">

        <template slot="createdByName"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toMemberDetail(scope.row.createdBy);"
              class="column-list-container-button">
            {{scope.row.createdByName}}</a>
        </template>

        <template slot="postCount"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toEssayList(scope.row.id);"
              class="column-list-container-button">
            {{scope.row.postCount}}</a>
        </template>

        <template slot="menuLeft" v-if="false">
          <el-button type="primary"
                     @click="handleAdd"
                     icon="el-icon-add"
                     size="small"
                     v-if="permissions.column_add">创建专栏</el-button>
          <br /><br />
        </template>
        <template slot-scope="scope"
                  slot="menu">
          <el-button type="text"
                     v-if="permissions.column_view"
                     icon="el-icon-view"
                     size="mini"
                     @click="handleView(scope.row,scope.index)">查看</el-button>
          <el-button type="text"
                     v-if="permissions.column_del && scope.row.isActive"
                     icon="el-icon-delete"
                     size="mini"
                     @click="handleDel(scope.row,scope.index)">关闭</el-button>
          <el-button type="text"
                     v-if="permissions.column_edit && scope.row.isActive"
                     icon="el-icon-sort"
                     size="mini"
                     @click="handleSort(scope.row,scope.index)">排序</el-button>
        </template>
      </avue-crud>
    </basic-container>
    <el-dialog title="排序设置" :visible.sync="dialogSortVisible" width="30%" class="sort-dialog">
      <div class="sort-dialog-item">
        <label class="sort-dialog-item-label">顺序：</label>
        <el-input v-model.trim="columnSort.sort" type="number" class="sort-dialog-item-input" clearable></el-input>
      </div>
      <div class="sort-dialog-footer">
        <el-button type="primary" class="sort-dialog-footer-save" @click="modifySortRule">修改</el-button>
        <el-button class="sort-dialog-footer-cancel" @click="dialogSortVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { fetchList, getObj, addObj, putObj, delObj, setPublic, updateCircleSort } from '@/api/post/circle'
  import { tableOption, isPublicOptions, isActiveOptions } from '@/const/crud/post/column'
  import { mapGetters } from 'vuex'
  export default {
    name: 'circle',
    data() {
      return {
        memberId: '',
        tableData: [],
        page: {
          total: 0, // 总记录数
          currentPage: 1, // 当前页数
          pageSize: 20 // 每页显示多少条
        },
        listQuery: {
          current: 1,
          size: 20,
          circleType: 1,
          circleName: '',
          createdByName: '',
          createdBy: '',
          tagName: '',
          location: '',
          company: '',
          isPublic: '',
          isActive: '',
          createTime: [],
          sortField: 'created_time',
          sortPolicy: 'desc'
        },
        tableLoading: false,
        tableOption: tableOption,
        isPublicOptions: isPublicOptions,
        isActiveOptions: isActiveOptions,
        dialogSortVisible: false,
        columnSort: {},
      }
    },
    created() {
      this.getList()
    },
    watch: {
      $route () {
        this.memberId = this.$route.query.memberId
        this.getList()
      }
    },
    mounted: function() {
      this.memberId = this.$route.query.memberId
      this.getList()
    },
    computed: {
      ...mapGetters(['permissions']),
      startTime: function () {
        if (this.listQuery.createTime && this.listQuery.createTime.length > 0) {
          return this.listQuery.createTime[0]
        } else {
          return null
        }
      },
      endTime: function () {
        if (this.listQuery.createTime && this.listQuery.createTime.length > 1) {
          return this.listQuery.createTime[1]
        } else {
          return null
        }
      }
    },
    methods: {
      getList() {
        this.tableLoading = true
        if (this.startTime && this.endTime) {
          this.listQuery.startTime = this.startTime
          let t = new Date(this.endTime)
          t.setDate(t.getDate() + 1)
          this.listQuery.endTime = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
        } else {
          this.listQuery.startTime = null
          this.listQuery.endTime = null
        }
        this.listQuery.createdBy = this.memberId

        fetchList(this.listQuery).then(response => {
          this.tableData = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.tableLoading = false
        }).catch(error => {
          console.error(error)
          this.$message({
            message: '获取专栏列表失败',
            type: 'error'
          })
          this.tableLoading = false
        })
      },
      formatData(records) {
        if (Array.isArray(records)) {
          records.forEach(circle => {
            circle.publicText = circle.isPublic ? '是' : '否'
            circle.activeText = circle.isActive ? '正常' : '已关闭'
            if (circle.postCount == null) circle.postCount = 0
            if (circle.memberCount == null) circle.memberCount = 0
          })
        }
        return records
      },
      searchReset() {
        this.listQuery.circleName = ''
        this.listQuery.createdByName = ''
        this.listQuery.tagName = ''
        this.listQuery.location = ''
        this.listQuery.company = ''
        this.listQuery.isPublic = ''
        this.listQuery.isActive = ''
        this.listQuery.createTime = []
        this.searchChange()
      },
      searchChange() {
        this.page.currentPage = 1
        this.listQuery.current = 1
        this.getList()
      },
      currentChange(val) {
        this.page.currentPage = val
        this.listQuery.current = val
        this.getList()
      },
      sizeChange(val) {
        this.page.currentPage = 1
        this.listQuery.current = 1
        this.page.pageSize = val
        this.listQuery.size = val
        this.getList()
      },
      handleAdd: function() {
        this.$router.push({
          path: '/post/column/add'
        })
      },
      handleEdit(row, index) {
        this.$router.push({
          path: '/post/column/edit',
          query: {
            id: row.id
          }
        })
      },
      handleView(row, index) {
        this.$router.push({
          path: `/post/column/detail/${row.id}`
        })
      },
      handleSort(row, index) {
        this.dialogSortVisible = true;
        this.columnSort = {
          circleId: row.id,
          sort: row.sort,
        }
      },
      modifySortRule() {
        updateCircleSort(this.columnSort).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: '修改排序成功',
              type: 'success'
            })
            this.getList();
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: '修改排序失败',
            type: 'error'
          })
        }).finally(() => {
          this.dialogSortVisible = false;
        })
      },
      handleDel(row, index) {
        this.$refs.crud.rowDel(row, index)
      },
      rowDel: function(row, index) {
        var _this = this
        this.$confirm('是否确认关闭专栏：' + row.circleName + ' ?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delObj(row.id).then(response => {
            if (response.data.data) {
              row.isActive = 0
              row.activeText = '已关闭'
              _this.$message({
                showClose: true,
                message: '关闭成功',
                type: 'success'
              })
            }
          }).catch(function(err) {
            console.error(err)
            _this.$message({
              showClose: true,
              message: '关闭失败',
              type: 'error'
            })
          })
        })
      },
      /**
       * 刷新回调
       */
      refreshChange() {
        this.getList()
      },
      sortChange (val) {
      // 检查排序对象
      if (val.prop === 'id') {
        this.listQuery.sortField = 'id'
      } else if (val.prop === 'createdTime') {
        this.listQuery.sortField = 'created_time'
      } else if (val.prop === 'postCount') {
        this.listQuery.sortField = 'post_count'
      } else if (val.prop === 'memberCount') {
        this.listQuery.sortField = 'member_count'
      } else if (val.prop === 'updatedTime') {
        this.listQuery.sortField = 'updated_time'
      } else if (val.prop === 'sort') {
        this.listQuery.sortField = 'sort'
      }

      // 检查排序方式
      if (val.order == 'ascending') {
        this.listQuery.sortPolicy = "asc"
      } else if (val.order == 'descending') {
        this.listQuery.sortPolicy = "desc"
      } else {
        this.listQuery.sortPolicy = ""
      }
      this.getList()
    },
      toMemberDetail(memberId) {
        // 点击作者，链接转到该作者的详情页面
        this.$router.push({
          path: "/upms/member/detail/" + memberId,
        })
      },
      toEssayList(id) {
        this.$router.push({
          path: "/post/essay",
          query: {
            columnId: id
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
.column-list {
  &-filter {
    margin: 0px 10px;
    background-color: #fff;
    padding-top: 20px;
    padding-left: 22px;
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: calc(100% - 90px) !important;
    }
    &-date {
      width: calc(100% - 150px) !important;
    }
    &-search {
      float: right;
      margin-right: 40px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
    }
  }
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
.sort-dialog {
  display: flex;
  flex-direction: column;
  &-item {
    width: 500px;
    display: flex;
    flex-direction: row;
    &-label {
      text-align: center;
      font-size: 14px;
      width: 50px;
      line-height: 36px;
      padding: 0 5px;
    }
    &-input {
      font-size: 14px;
      width: 300px;
      height: 36px;
    }
  }
  &-footer{
    display: flex;
    flex-direction: row;
    padding: 20px 0px;
    &-save {
      padding: 8px 12px;
      position: absolute;
      right: 90px;
    }
    &-cancel {
      padding: 8px 12px;
      position: absolute;
      right: 10px;
      margin-right: 10px;
    }
  }
}
</style>

